import type {AxiosResponse} from 'axios'
import type {
  AuthAccessTokenReq,
  AuthAccessTokenRes,
  AuthAuthorizeReq,
  AuthMobileBindReq,
  AuthSmsLoginReq,
  AuthSmsLoginRes,
  AuthSmsSendReq,
  ProfileUpdateReq, UserProfile,
  UserVo,
} from '@/api/auth/types.ts'
import api from '@/utils/axios.ts'

/**
 * 社交用户授权,获取code
 */
export function authAuthorize(data: AuthAuthorizeReq): Promise<AxiosResponse<string>> {
  return api({
    url: '/api/auth/authorize',
    method: 'post',
    data,
  })
}

/**
 * 根据code获取第三方访问令牌
 */
export function authAccessToken(data: AuthAccessTokenReq): Promise<AxiosResponse<AuthAccessTokenRes>> {
  return api({
    url: '/api/auth/token',
    method: 'post',
    data,
  })
}

/**
 * 首次登录-绑定手机号
 */
export function bindMobileApi(data: AuthMobileBindReq): Promise<AxiosResponse<AuthSmsLoginRes>> {
  return api({
    url: '/api/auth/bind-mobile',
    method: 'post',
    data,
  })
}

/**
 * 绑定第三方用户
 */
export function bindThirdPartyApi(code: string): Promise<AxiosResponse<boolean>> {
  return api({
    url: '/auth/bind-third-party',
    method: 'post',
    data: {
      type: 'wechat',
      code,
    },
  })
}

/**
 * 使用手机 + 验证码登录
 */
export function authSendSms(data: AuthSmsSendReq): Promise<AxiosResponse<boolean>> {
  return api({
    url: '/api/auth/send-sms',
    method: 'post',
    data,
  })
}

/**
 * 使用手机 + 验证码登录
 */
export function authSmsLogin(data: AuthSmsLoginReq): Promise<AxiosResponse<AuthSmsLoginRes>> {
  return api({
    url: '/api/auth/sms-login',
    method: 'post',
    data,
  })
}

/**
 * 内部登录：账号 + 密码（账号体系复用工作台）
 */
export function authPasswordLogin(data: { account: string, password: string }): Promise<AxiosResponse<AuthSmsLoginRes>> {
  return api({
    url: '/api/auth/password-login',
    method: 'post',
    data,
  })
}

/**
 * 用户退出
 */
export function authLogout() {
  return api({
    url: '/auth/logout',
    method: 'post',
  })
}

/**
 * 获取个人信息
 */
export function getProfileApi(): Promise<AxiosResponse<UserVo>> {
  return api({
    url: '/auth/profile/get',
    method: 'post',
  })
}

/**
 * 获取指定用户信息
 */
export function getUserProfileApi(userId: string): Promise<AxiosResponse<UserProfile>> {
  return api({
    url: `/api/user/profile/${userId}`,
    method: 'post',
  })
}

/**
 * 更换头像：上传图片文件流到 /auth/profile/avatar
 */
export function uploadProfileAvatarApi(file: File) {
  const formData = new FormData()
  formData.append('file', file)
  return api({
    url: '/auth/profile/avatar',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * 修改个人信息（昵称、简介）
 */
export function updateProfileApi(data: ProfileUpdateReq) {
  return api({
    url: '/auth/profile/update',
    method: 'post',
    data,
  })
}
